var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97901 17H16.021C16.5762 17 17.0262 16.5523 17.0262 16V15.618C17.0262 15.2393 17.2433 14.8971 17.5666 14.697C18.6969 13.997 20.2205 12.662 21.1693 10.75H2.83075C3.77954 12.662 5.30312 13.997 6.43342 14.697C6.75666 14.8971 6.97376 15.2393 6.97376 15.618V16C6.97376 16.5523 7.42383 17 7.97901 17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25347 9.25C2.14225 8.85145 2.05788 8.43426 2.0062 7.99876C1.94111 7.45029 2.39759 7 2.95278 7H21.0472C21.6024 7 22.0589 7.45029 21.9938 7.99876C21.9421 8.43426 21.8578 8.85145 21.7465 9.25H2.25347Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowl);
export default __webpack_public_path__ + "static/media/bowl.ac4c7b976903fb094e9081a40db6eb6c.svg";
export { ForwardRef as ReactComponent };